var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoImpressora01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1459",
    d: "M30.3,9.3h-1V5.7c0-2.8-2.3-5.1-5.1-5.1H11.7c-2.8,0-5.1,2.3-5.1,5.1v3.7h-1c-2.8,0-5.1,2.3-5.1,5.1v8.2 c0,2.8,2.3,5.1,5.1,5.1h1v4.6c0,1.7,1.4,3.1,3.1,3.1h16.6c1.7,0,3.1-1.4,3.1-3.1v-4.6h1c2.8,0,5.1-2.3,5.1-5.1v-8.2 C35.5,11.6,33.2,9.3,30.3,9.3z M8.7,5.7c0-1.7,1.4-3.1,3.1-3.1h12.6c1.7,0,3.1,1.4,3.1,3.1v3.7H8.7V5.7z M27.3,32.4 c0,0.6-0.5,1-1,1H9.7c-0.6,0-1-0.5-1-1V22.3h18.7V32.4z M33.4,22.6c0,1.7-1.4,3.1-3.1,3.1h-1v-3.4H30c0.6,0,1-0.5,1-1.1 c0-0.5-0.4-1-1-1H6c-0.6,0-1,0.4-1.1,1s0.4,1,1,1.1c0,0,0.1,0,0.1,0h0.6v3.4h-1c-1.7,0-3.1-1.4-3.1-3.1v-8.2c0-1.7,1.4-3.1,3.1-3.1 h24.7c1.7,0,3.1,1.4,3.1,3.1L33.4,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1460",
    d: "M20.7,24.6h-5.5c-0.6,0-1,0.5-1,1.1c0,0.5,0.4,1,1,1h5.5c0.6,0,1-0.5,1-1.1 C21.7,25.1,21.3,24.6,20.7,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1461",
    d: "M20.7,29h-5.5c-0.6,0-1,0.5-1,1.1c0,0.5,0.4,1,1,1h5.5c0.6,0,1-0.5,1-1.1C21.7,29.4,21.3,29,20.7,29z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1462",
    d: "M9.3,13.7H6c-0.6,0-1,0.5-1,1.1c0,0.5,0.4,1,1,1h3.3c0.6,0,1-0.4,1.1-1C10.4,14.2,9.9,13.7,9.3,13.7 C9.3,13.7,9.3,13.7,9.3,13.7L9.3,13.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoImpressora01);
export default __webpack_public_path__ + "static/media/ico-impressora-01.0bb036b864df0524e75527e1ae8212d0.svg";
export { ForwardRef as ReactComponent };